<template>
    <div>
        <div class="text-xs-center" v-if="!items">
            <br/><br/>
            <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
            ></v-progress-circular> &nbsp;&nbsp; BUSCANDO CLIENTES
        </div>

        <v-list two-line subheader v-if="items && items.length">

            <template v-for="(item, index) in items">
                <div :key="index">
                    <v-divider :inset="item.inset"  ></v-divider>
                    <v-list-tile avatar >

                        <v-list-tile-avatar>
                            <v-icon v-if="item.sessao_online.online" :class="'green lighten-1 white--text'">network_wifi</v-icon>
                            <v-icon v-else :class="'red lighten-1 white--text'">not_interested</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.cliente.nome }}</v-list-tile-title>
                            <v-list-tile-sub-title v-if="item.sessao_online.online">
                                ONLINE - RX: <b v-if="item.ftth.info">{{item.ftth.info.onu.rx_power.value}}</b>
                            </v-list-tile-sub-title>
                            <v-list-tile-sub-title v-else>
                                OFFLINE  - RX: <b v-if="item.ftth.info">{{item.ftth.info.onu.rx_power.value}}</b>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>

                    </v-list-tile>
                </div>
            </template>

        </v-list>

        <v-container v-if="items && !items.length">
            <v-alert
                    :value="true"
                    color="info"
                    icon="info"
                    outline
            >
                NENHUM FTTH NESTA CAIXA
            </v-alert>
        </v-container>

    </div>

</template>

<script>
    import { Caixas } from "../../class/caixas"
    export default {
        name: "ClientesFtthNaCaixa",
        data () {
            return {
                items: null,
                interval: null
            }
        },
        props: {
            id: {
                default: null
            }
        },
        beforeDestroy () {
            clearInterval(this.interval);
        },
        beforeMount () {
            this.load();
            this.interval = setInterval(() => this.loadUpdate(), 150000);
        },
        methods: {
            load () {
                Caixas
                    .clientesFtth(this.id)
                    .then((json) => {
                        console.log(json);
                        this.items = json.data
                    })
                    .then(() => setTimeout(() => this.loadUpdate(), 5000));
            },

            loadUpdate () {
                Caixas
                    .clientesFtthUpdate(this.id)
                    .then((json) => {
                        this.items = json.data
                    });
            }
        }
    }
</script>

<style scoped>

</style>
